'use client';

import type {FC, HTMLAttributes} from 'react';
import {AnimatePresence, motion} from 'framer-motion';

interface Props extends HTMLAttributes<HTMLDivElement> {
	delay?: number;
	duration?: number;
}

export const FadeInDownDiv: FC<Props> = (
	{children, className, duration = 0.7, delay = 0},
	...rest
) => {
	return (
		<AnimatePresence>
			<motion.div
				{...rest}
				className={className}
				initial={{opacity: 0, y: -60}}
				animate={{opacity: 1, y: 0}}
				transition={{duration, delay}}
			>
				{children}
			</motion.div>
		</AnimatePresence>
	);
};
